function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M0 0h52v52H0z"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10.5 9.67A22.443 22.443 0 0 1 25.988 3.5C38.42 3.5 48.5 13.573 48.5 26c0 12.426-10.079 22.5-22.512 22.5a22.434 22.434 0 0 1-14.837-5.577"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M28.5 26a2.5 2.5 0 1 1-5.001 0 2.5 2.5 0 0 1 5.001 0zm0-2.5l11-10m-11 14l7 7"
}), React.createElement("path", {
  fill: "#3FC0C4",
  d: "M27.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-17 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m35 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-18 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.5 14.316l5-1.816c-2.637 3.632-4.259 8.755-4.259 13.36 0 4.683 1.337 9.032 3.624 12.64"
}), React.createElement("path", {
  stroke: "#41BFC3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.111 16.5l-1.611-4"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.996 35.5l-.71 4L3.5 38.207"
}));

var SvgFlexiblehours = function SvgFlexiblehours(props) {
  return React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI1MiIgdmlld0JveD0iMCAwIDUyIDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMCAwaDUydjUySDB6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjM0ZDMEM0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTEwLjUgOS42N0EyMi40NDMgMjIuNDQzIDAgMCAxIDI1Ljk4OCAzLjVDMzguNDIgMy41IDQ4LjUgMTMuNTczIDQ4LjUgMjZjMCAxMi40MjYtMTAuMDc5IDIyLjUtMjIuNTEyIDIyLjVhMjIuNDM0IDIyLjQzNCAwIDAgMS0xNC44MzctNS41NzciLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMjguNSAyNmEyLjUgMi41IDAgMSAxLTUuMDAxIDAgMi41IDIuNSAwIDAgMSA1LjAwMSAwek0yOC41IDIzLjVsMTEtMTBNMjguNSAyNy41bDcgNyIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMzRkMwQzQiIGQ9Ik0yNy41IDlhMS41IDEuNSAwIDEgMS0zIDAgMS41IDEuNSAwIDAgMSAzIDBNMTAuNSAyNmExLjUgMS41IDAgMSAxLTMgMCAxLjUgMS41IDAgMCAxIDMgME00NS41IDI2YTEuNSAxLjUgMCAxIDEtMyAwIDEuNSAxLjUgMCAwIDEgMyAwTTI3LjUgNDRhMS41IDEuNSAwIDEgMS0zIDAgMS41IDEuNSAwIDAgMSAzIDAiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMi41IDE0LjMxNmw1LTEuODE2Yy0yLjYzNyAzLjYzMi00LjI1OSA4Ljc1NS00LjI1OSAxMy4zNiAwIDQuNjgzIDEuMzM3IDkuMDMyIDMuNjI0IDEyLjY0Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjNDFCRkMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTkuMTExIDE2LjVsLTEuNjExLTQiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNOC45OTYgMzUuNWwtLjcxIDRMMy41IDM4LjIwNyIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlexiblehours as ReactComponent };